import React, {Component} from 'react'
import Star from "../star";
import './stars.css';
import PropTypes from "prop-types";

class Stars extends Component {

    render() {
        const starCount = 5;
        let stars = [];
        for(var i=1; i<=starCount; i++){
            let active = i <= this.props.mark ? true : false;
            stars.push(
                <Star
                    active={active}
                    key={i}
                    id={i}
                    onClick={this.props.handleVote.bind(this, i)}
                />
            );
        };

        return (
            <div className='Stars'>
                <span className="Stars__text">{'Špatné'}</span>
                <div className="Stars__stars">
                    {stars}
                </div>
                <span className="Stars__text">{'Nejlepší'}</span>
            </div>
        );
    }
}

Stars.propTypes = {
    mark: PropTypes.oneOf([null, 1, 2, 3, 4, 5]),
    handleVote: PropTypes.func.isRequired,
};

export default Stars;


// WEBPACK FOOTER //
// ./src/components/stars/index.js